export class MoleculePanelOverviewHeaderMultiLockSubaccountActionComponent {
    public templateUrl = require('./multi-lock-subaccount-action.html?external');
}
